<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="updateAbsenceRequest" (change)="updateAbsenceRequestChange()"
        (submit)="updateAbsenceRequestSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"ABSENCE_ASSIGNMET_UPDATE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0"
                    routerLink="/attendence/authorized-absence-request" *ngIf="!updating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!updating"><i
                        class="fas fa-user-plus"></i>
                    {{"UPDATE" | translate | titlecase }}</button>
                <app-loader [show]="updating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "STUDENT_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="remarks">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateAbsenceRequest.controls.remarks.touched && updateAbsenceRequest.controls.remarks.invalid && updateAbsenceRequest.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "REMARKS" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="remarks">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateAbsenceRequest.controls.remarks.touched && updateAbsenceRequest.controls.remarks.invalid && updateAbsenceRequest.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ASSIGMENT_DES" | translate | titlecase }}</label>
                                <textarea class="form-control" formControlName="assignmentDes"> </textarea>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateAbsenceRequest.controls.assignmentDes.touched && updateAbsenceRequest.controls.assignmentDes.invalid && updateAbsenceRequest.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ASSIGMENT_DES_FILE" | translate | titlecase }} <span> : <a href="{{attachmentFileLink}}" target="_blank" *ngIf="oldAbsenceFileName.length > 0">{{ "VIEW" |
                                    translate | titlecase }}</a></span></label>
                                <input type="file" class="form-control" formControlName="assignmentDesFile"
                                (change)="changeFile($event)">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateAbsenceRequest.controls.assignmentDesFile.touched && updateAbsenceRequest.controls.assignmentDesFile.invalid && updateAbsenceRequest.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ASSIGMENT_ANS" | translate | titlecase }}</label>
                                <textarea class="form-control" formControlName="assignmentAns"> </textarea>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateAbsenceRequest.controls.assignmentAns.touched && updateAbsenceRequest.controls.assignmentAns.invalid && updateAbsenceRequest.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ASSIGMENT_ANS_FILE" | translate | titlecase }} <span> : <a href="{{attachmentFileLink}}" target="_blank" *ngIf="oldAbsenceFileName.length > 0">{{ "VIEW" |
                                    translate | titlecase }}</a></span></label>
                                <input type="file" class="form-control" formControlName="assignmentAnsFile"
                                (change)="changeFile($event)">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateAbsenceRequest.controls.assignmentAnsFile.touched && updateAbsenceRequest.controls.assignmentAnsFile.invalid && updateAbsenceRequest.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>